import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export type ToastTone = "success" | "danger" | "neutral";

export interface ToastMessage {
  id: number;
  title: string;
  message?: string;
  tone: ToastTone;
}

@Injectable()
export class ToastService {
  private counter = 0;
  private readonly _messages = new BehaviorSubject<ToastMessage[]>([]);

  readonly messages$ = this._messages.asObservable();

  success(title: string, message = "") {
    this.show({ title, message, tone: "success" });
  }

  error(title: string, message = "") {
    this.show({ title, message, tone: "danger" });
  }

  info(title: string, message = "") {
    this.show({ title, message, tone: "neutral" });
  }

  remove(id: number) {
    this._messages.next(this._messages.value.filter((item) => item.id !== id));
  }

  private show(input: Omit<ToastMessage, "id">) {
    const id = ++this.counter;
    const item: ToastMessage = { id, ...input };
    this._messages.next([...this._messages.value, item]);
    setTimeout(() => {
      this.remove(id);
    }, 3600);
  }
}
